import useGlobalStore from '@/store/useGlobalStore'
import { useEffect, useState } from 'react'
import type { HydraGetSubscriptionItem } from '@/lib/services/Hydra/account/GET/getSubscriptions'

export const useGetSelectedSubscription = () => {
  const {
    app: {
      addProductToSubscription: { selectedSubscriptionId },
    },
    subscriptions,
  } = useGlobalStore()

  const [selectedSubscription, setSelectedSubscription] =
    useState<HydraGetSubscriptionItem | null>(null)

  useEffect(() => {
    if (selectedSubscriptionId && subscriptions.items) {
      const subscription = subscriptions.items.find(
        (item) => item.id.unicity === selectedSubscriptionId,
      )
      setSelectedSubscription(subscription || null)
    } else {
      setSelectedSubscription(null)
    }
  }, [selectedSubscriptionId, subscriptions.items])

  return { selectedSubscription }
}
